import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { useAsync, useAsyncFn } from 'react-use';
import { bindActionCreators } from 'redux';

import { ibeCustomPermissions } from 'actions/user/beCustomPermissions.action';
import { ibeStylistPermissionsRead } from 'actions/user/beStylistPermissions.action';
import Permitted from 'components/core/Permitted.component';
import Button from 'components/form/Button.component';
import PERM from 'constants/core/perm.const';
import { fromEventToValue } from 'utils/converters/event.util';
import logger from 'utils/logger.util';

import CN from './AccessPage.module.scss';

const L = logger('AccessPage');

const pretty = ($) => JSON.stringify($, null, 2);

const AccessPage = ({ ibeCustomPermissions, ibeStylistPermissionsRead }) => {
  const [stylistId, setStylistId] = useState('49126');

  const {
    value: valueAll,
    loading: isLoadingAll,
    error: errorAll,
  } = useAsync(async () => {
    const result = await ibeCustomPermissions();
    return { ng: result.json, og: result.originalJson };
  }, [ibeCustomPermissions]);

  const handleStylistId = useCallback((ev) => void setStylistId(fromEventToValue(ev)), []);

  const [{ value: valueOne, loading: isLoadingOne, error: errorOne }, handleSubmit] = useAsyncFn(async () => {
    const result = await ibeStylistPermissionsRead({ stylistId });
    return { ng: result.json, og: result.originalJson };
  }, [ibeStylistPermissionsRead, stylistId]);

  L.debug('()', isLoadingAll || isLoadingOne, errorAll || errorOne, { valueAll, valueOne });

  return (
    <div data-bem="AccessPage" className={CN.component}>
      <p>
        In this box there is: <code>{`<Permitted value="none" />`}</code>
        <span className={CN.box}>
          <Permitted value="none" tag="Application__permitted--01">
            Just a testing one
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value="missing" />`}</code>
        <span className={CN.box}>
          <Permitted value="missing" tag="Application__permitted--02">
            Just a missing one
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value="test" />`}</code>
        <span className={CN.box}>
          <Permitted value="test" tag="Application__permitted--03">
            Just a missing one
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value="-1" />`}</code>
        <span className={CN.box}>
          <Permitted value="-1" tag="Application__permitted--04">
            -1 is a string
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value={-1} />`}</code>
        <span className={CN.box}>
          <Permitted value={-1} tag="Application__permitted--05">
            -1 is a number
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value="none_none:none" />`}</code>
        <span className={CN.box}>
          <Permitted value="none_none:none" tag="Application__permitted--06">
            none:none is a snaked string
          </Permitted>
        </span>
      </p>

      <p>
        In this box there is: <code>{`<Permitted value={PERM.none} />`}</code>
        <span className={CN.box}>
          <Permitted value={PERM.none} tag="Application__permitted--07">
            none is an object
          </Permitted>
        </span>
      </p>

      <p className={CN.vertical}>
        <span>
          Enter some stylist ID, like <code>49126</code>, <code>44356</code>
        </span>
        <input value={stylistId} onChange={handleStylistId} />
        <Button onClick={handleSubmit}>Submit</Button>
      </p>
      <pre className={CN.pre}>{pretty(valueOne?.og)}</pre>
      <pre className={CN.pre}>{pretty(valueAll?.ng?.[0])}</pre>
      <pre className={CN.pre}>{pretty(valueAll?.og?.results?.permission_details?.['Account Settings'])}</pre>
    </div>
  );
};

const AccessPageHoc = connect(null, (dispatch) =>
  bindActionCreators(
    {
      ibeCustomPermissions,
      ibeStylistPermissionsRead,
    },
    dispatch,
  ),
)(AccessPage);

// noinspection JSUnusedGlobalSymbols
export default AccessPageHoc;
